/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ChevronUpDownIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Chevron Up Down',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M28 11.98a2 2 0 0 1-3.411 1.411l-6.577-6.573-6.578 6.572a2 2 0 0 1-2.874-2.773l.049-.049L16.6 2.585a2 2 0 0 1 2.825 0l7.989 7.983A1.989 1.989 0 0 1 28 11.98ZM8 24.02a2 2 0 0 1 3.411-1.411l6.578 6.572 6.578-6.572a2 2 0 0 1 2.874 2.773l-.049.049-7.992 7.983a2 2 0 0 1-2.825 0l-7.989-7.983A1.989 1.989 0 0 1 8 24.02Z"
    />
  </svg>`;
};
